var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.07157 9.92928L6.33704 9.87416H7.64712H16.3564H17.6647L17.9308 9.92957C19.1272 10.1787 20.0253 11.2422 20.0253 12.511V17.8828C20.0253 19.3391 18.8448 20.5196 17.3885 20.5196H6.61245C5.15619 20.5196 3.97565 19.339 3.97565 17.8828V12.511C3.97565 11.2417 4.87445 10.1778 6.07157 9.92928ZM22.0029 12.511C22.0029 10.2865 20.4289 8.42971 18.334 7.99349V7.89655V7.24731C18.334 4.07473 15.7621 1.50284 12.5895 1.50284H11.414C8.2414 1.50284 5.66951 4.07472 5.66951 7.24731L5.66951 7.89655L5.66951 7.99298C3.57328 8.42824 1.99805 10.2856 1.99805 12.511V17.8828C1.99805 20.4312 4.06399 22.4972 6.61245 22.4972H17.3885C19.937 22.4972 22.0029 20.4313 22.0029 17.8828V12.511ZM7.64712 7.24731C7.64712 6.77973 7.73231 6.33206 7.88802 5.91895C8.4251 4.49403 9.80118 3.48044 11.414 3.48044H12.5895C14.2023 3.48044 15.5784 4.49403 16.1155 5.91895C16.2709 6.33126 16.356 6.778 16.3564 7.2446L16.3564 7.24731L16.3564 7.89655H14.3787H9.62472H7.64712V7.24731ZM12.9892 14.3066C12.9892 13.7605 12.5465 13.3178 12.0004 13.3178C11.4543 13.3178 11.0116 13.7605 11.0116 14.3066V16.0872C11.0116 16.6333 11.4543 17.076 12.0004 17.076C12.5465 17.076 12.9892 16.6333 12.9892 16.0872V14.3066Z",
    fill: "#6E7DAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.d3b841feead13cf0d8e498dd3cdbc956.svg";
export { ForwardRef as ReactComponent };